module.exports = __webpack_public_path__ + "img/10.b2c1e71d.jpg";